import { TOKEN } from 'utils/constants'

export const INIT_SESSION_ACTION = 'SessionProvider/INIT_SESSION_ACTION'

export const SET_SESSION_ACTION = 'SessionProvider/SET_SESSION_ACTION'

export const REMOVE_SESSION_ACTION = 'SessionProvider/REMOVE_SESSION_ACTION'

export { TOKEN }
